module.exports = __webpack_public_path__ + "img/bigpackfast-badge.4914b58a.svg";